const config = {
  rowSelection: false,
  columns: [
    {
      title: '线索ID',
      dataIndex: 'id',
      width: 190,
    },
    {
      title: '客户姓名',
      dataIndex: 'name',
      width: 130
    },
    {
      title: '客户手机电话',
      dataIndex: 'phone',
      width: 140,
      render: 'checkPhone',
    },
    {
      title: '房屋状态',
      dataIndex: 'houseStatusName',
      width: 100
    },
    {
      title: '房屋类型',
      dataIndex: 'houseKindName',
      width: 100
    },
    {
      title: '渠道来源',
      dataIndex: 'channelPathDesc',
      ellipsis: true,
      width: 230
    },
    {
      title: '城市',
      dataIndex: 'cityName',
      width: 150
    },
    {
      title: '第三方标单号',
      dataIndex: 'otherId',
      width: 140
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 200,
      ellipsis: true,
    },
    {
      title: '线索状态',
      dataIndex: 'clueStatusName',
      width: 120
    },
    {
      title: '流转失败原因',
      dataIndex: 'dispatchExceptionDesc',
      width: 230
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      itemType: 'dateTime',
      width: 160,
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 120,
      render: 'renderOperate',
      fixed: 'right'
    },
  ],
  search: [
    {
      name: 'id',
      label: '线索ID',
      placeholder: '线索ID',
      span: 150,
      formItemProps: {
        getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
      },
    },
    {
      name: 'nameLike',
      label: '客户姓名',
      placeholder: '客户姓名',
      span: 150,
    },
    {
      name: 'phone',
      label: '客户电话',
      placeholder: '客户电话',
      span: 150,
      formItemProps: {
        getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
      },
    },
    {
      name: 'clueStatus',
      label: '线索状态',
      placeholder: '线索状态',
      itemType: 'select',
      key: 'key',
      labelKey: 'description',
      data: 'clueStatusList',
      allowClear: true,
    },
    {
      name: 'channelIds',
      label: '客户来源',
      itemType: 'custom',
      render: 'treeSelect',
      data: 'channel',
      allowClear: true,
      showSearch: true,
    },
    {
      name: 'createdTime',
      label: '创建时间',
      placeholder: ['创建时间起', '止'],
      itemType: 'autoDate',
      showTime: 'true',
      colSpan: 2,
      searchFormConfig: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
          xl: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 },
          xl: { span: 19 },
        },
      },
    },
  ],
  footer: [
    {
      label: '导入',
      itemType: 'custom',
      render: 'importRender'
    },
    {
      label: '导出',
      type: 'primary',
      events: ['onClick:exportHandler'],
    },
  ],
}

export default config
